// extracted by mini-css-extract-plugin
module.exports = {"header":"patientDetailsPage_header__CaKeR","patientDetailsPage":"patientDetailsPage_patientDetailsPage__2gAiJ"};